import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class MailTokenGuard implements CanActivate {
  public path: ActivatedRouteSnapshot[];
  public route: ActivatedRouteSnapshot;

  constructor(public router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean  {
    const token = next.queryParams.key;
    if (!token) {
      this.router.navigateByUrl('login');
    }
    return true;
  }
}
